import { render, staticRenderFns } from "./adressList.vue?vue&type=template&id=43f01937&scoped=true&"
import script from "./adressList.vue?vue&type=script&lang=js&"
export * from "./adressList.vue?vue&type=script&lang=js&"
import style0 from "./adressList.vue?vue&type=style&index=0&id=43f01937&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f01937",
  null
  
)

export default component.exports